import React from 'react';
import styles from './FieldInputWrapper.module.scss';
import { FieldType } from '@/services/formSchema.service';
import { FieldInput, IDynamicInput } from '@/components/dynamic-field/field-input/FieldInput';
import { FieldCheckbox } from '@/components/dynamic-field/field-checkbox/FieldCheckbox';
import classNames from 'classnames';
import { FieldFile } from '@/components/dynamic-field/field-file/FieldFile';
import { FieldSelect } from '@/components/dynamic-field/field-select/FieldSelect';
import { FieldError, get } from 'react-hook-form';

export const FieldInputWrapper: React.FC<IDynamicInput> = ({
    fieldProperties,
    fieldName,
    fieldType,
    setValue,
    initialValue,
    register,
    validation,
    formValues,
    control,
    errors,
    watch,
}) => {
    const inputStyles = classNames(styles.wrapperInput, styles.wrapperInputText, {
        [styles.wrapperInputError]: (get(errors, fieldName) as FieldError)?.message,
    });
    const fieldInput = (
        <FieldInput
            fieldType={fieldType}
            initialValue={initialValue}
            fieldProperties={fieldProperties}
            register={register}
            formValues={formValues}
            fieldName={fieldName}
            validation={validation}
            setValue={setValue}
            watch={watch}
            control={control}
        />
    );

    if (fieldType === FieldType.CHECKBOX) {
        return (
            <FieldCheckbox
                fieldInput={fieldInput}
                description={fieldProperties.description}
                label={fieldProperties.label}
                validation={validation}
            />
        );
    }

    if (fieldType === FieldType.ARRAY) {
        return (
            <FieldSelect
                control={control}
                fieldName={fieldName}
                register={register}
                validation={validation}
                fieldProperties={fieldProperties}
            />
        );
    }

    if (fieldType === FieldType.FILE) {
        return (
            <div className={inputStyles}>
                <FieldFile fieldInput={fieldInput} fieldName={fieldName} formValues={formValues} control={control} />
            </div>
        );
    }

    return <div className={inputStyles}>{fieldInput}</div>;
};
